import { createLogic } from "redux-logic";
import * as DOMUtils from "history/DOMUtils";
import type { CarConfigLogicType } from "../store";
import {
    finishAvailableGradesForConfigurableFetch,
    startAvailableGradesForConfigurableFetch,
} from "../slices/CarConfigAvailableInOtherGradesSlice";
import Debug from "../../../../../common-deprecated/Debug";
import { getFetcher } from "../../../../../common-deprecated/api-clients/ApiClient";
import availableInOtherGradesClient from "../../api-clients/availableInOtherGrades";
import { addErrorLog, addRequestLog } from "../../../../../common-deprecated/redux/actions/UtilActions";

const startAvailableGradesForConfigurableFetchLogic = (
    createLogic as CarConfigLogicType<ReturnType<typeof startAvailableGradesForConfigurableFetch>>
)({
    type: startAvailableGradesForConfigurableFetch.type,

    latest: true,
    validate({ action }, allow, reject) {
        if (!DOMUtils.canUseDOM) {
            (reject as () => void)();
        } else {
            allow(action);
        }
    },

    async process({ getState, action }, dispatch, done) {
        try {
            const { car, basket, commonSettings } = getState();

            const { configurationObjectType, configurationObjectId } = action.payload;

            const fetcher = getFetcher(availableInOtherGradesClient, {
                commonSettings,
                modelId: car.model.id,
                bodyTypeId: car.body.id,
                carId: car.id,
                colourId: basket.colour.id,
                upholsteryId: basket.upholstery.id,
                wheelId: basket.wheel.id,
                configurationObjectType,
                configurationObjectId,
            });
            const result = await fetcher();

            const { fetchResult, reqLogs, errorLogs } = result;

            if (reqLogs?.length) dispatch(addRequestLog(reqLogs));
            if (errorLogs?.length) dispatch(addErrorLog(errorLogs));

            dispatch(
                finishAvailableGradesForConfigurableFetch({
                    availableGradesForConfigurable: {
                        ...fetchResult.availableGradesForConfigurable,
                        selectedGradeId: fetchResult.availableGradesForConfigurable.grades[0].id, // Select first grade by default.
                    },
                }),
            );
        } catch (ex) {
            Debug.error("Failed to fetch availableGradesForConfigurable", ex);
            dispatch(
                finishAvailableGradesForConfigurableFetch({
                    availableGradesForConfigurable: {
                        error: true,
                        fetching: false,
                        grades: [],
                    },
                }),
            );
        }
        done();
    },
});

export default [startAvailableGradesForConfigurableFetchLogic];
